import React, { useState } from 'react';
import { Badge, Button, Spinner, Alert } from 'react-bootstrap'; // Added Alert for better error display
import RecipeDetails from './RecipeDetails';
// --- IMPORTAR LA FUNCIÓN DEL SERVICIO ---
import { callPollinationsTextApi } from '../../services/aiService'; // Ajusta esta ruta a tu archivo de servicio

const AlternativeItem = ({ alternative, index }) => {
    const [recipe, setRecipe] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showRecipe, setShowRecipe] = useState(false);

    const fetchRecipe = async () => {
        if (showRecipe) {
            setShowRecipe(false);
            return;
        }
        if (recipe) {
            setShowRecipe(true);
            return;
        }

        setLoading(true);
        setError('');
        setRecipe(null);

        const systemPrompt = `
You are a world-class expert in nutrition and cooking. You will provide detailed and healthy recipe instructions for a user.
The user is looking for a healthy recipe for the dish called "${alternative.name}".
Provide the recipe in the following JSON format:

{
  "ingredients": ["ingredient 1 with quantity", "ingredient 2 with quantity"],
  "steps": ["step 1 detailed", "step 2 detailed"]
}

Ensure the ingredients list includes quantities suitable for 1-2 servings.
The steps should be clear and easy to follow.
Do not include any extra explanation or text outside the JSON object.
Focus on a healthy version of the dish. If the original dish is inherently unhealthy, provide a healthier take on it or a similar healthy alternative.
`;

        const userPrompt = `Please provide the full recipe for the dish called "${alternative.name}", including ingredients and preparation steps in the specified JSON format.`;

        try {
            // --- USAR LA FUNCIÓN DEL SERVICIO ---
            const result = await callPollinationsTextApi(
                systemPrompt,
                userPrompt, // El userPrompt aquí es simple, la info principal va en el systemPrompt
                {
                    model: 'openai-large', // O el modelo que prefieras para recetas
                    isJsonExpected: true   // Definitivamente esperamos JSON
                }
            );
            // --- FIN USO DE LA FUNCIÓN DEL SERVICIO ---

            // La función de servicio ya maneja el parseo y los errores básicos de API/parseo
            if (result && result.ingredients && Array.isArray(result.ingredients) && result.steps && Array.isArray(result.steps)) {
                setRecipe({
                    ingredients: result.ingredients,
                    steps: result.steps
                });
                setShowRecipe(true);
            } else {
                console.error("Received invalid recipe structure from API:", result);
                throw new Error('The generated recipe data is incomplete or not in the expected format.');
            }
        } catch (err) {
            console.error(`Error loading recipe for ${alternative.name}:`, err);
            setError(`Error loading recipe: ${err.message}`); // Muestra un mensaje de error más informativo
        } finally {
            setLoading(false);
        }
    };

    // Estilos para badges (puedes moverlos a CSS si prefieres)
    const badgeStyle = {
        fontSize: '0.8rem',
        fontWeight: 'bold',
        padding: '0.4em 0.8em',
        marginRight: '0.5rem',
    };

    return (
        <div className="alternative-item mb-4 p-3 border rounded shadow-sm bg-light">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="alternative-name mb-0 d-flex align-items-center">
                    <Badge bg="success" pill style={badgeStyle} className="me-2">
                        Option {index + 1}
                    </Badge>
                    {alternative.name}
                </h5>
                <Button variant="primary" size="sm" onClick={fetchRecipe} disabled={loading} style={{ minWidth: '120px' }}>
                    {loading ? <Spinner as="span" size="sm" animation="border" className="me-1" /> : showRecipe ? 'Hide Recipe' : 'View Recipe'}
                </Button>
            </div>

            <p className="alternative-benefits text-muted small mb-2">{alternative.benefits}</p>
            {alternative.whereToFind && (
                <p className="small mb-2"><strong>Where to find:</strong> {alternative.whereToFind}</p>
            )}


            {error && <Alert variant="danger" className="mt-2 py-1 px-2 small">{error}</Alert>}

            {showRecipe && recipe && (
                <div className="mt-3 pt-3 border-top">
                    <RecipeDetails name={alternative.name} recipe={recipe} />
                </div>
            )}
        </div>
    );
};

export default AlternativeItem;